export enum EMethodePrelevement {
    Impaction = 1,
    Sedimentation = 2,
}